interface EnumType {
  label: string | number
  value?: string | number
  disabled?: boolean
}

interface FilterOptions {
  enum?: EnumType[]
  width?: string
  tooltip?: string
  allowClear?: boolean
  mode?: 'multiple' | 'tags'
  min?: number
  max?: number
}

interface filtersType {
  type:
    | 'input-string'
    | 'input-integer'
    | 'select'
    | 'phone'
    | 'dates'
    | 'filter_group'
    | 'select_multiple'
    | 'range'
  items?: filtersType[]
  name: string
  label?: string
  options?: FilterOptions
  style?: React.CSSProperties
  placeholder?: string | string[]
  prefix?: string
  disabled?: boolean
  value?: string | number | readonly string[] | string[]
  skipReset?: boolean
}

export const getFilters = ({ currentFilters, availableFilters, stages }): filtersType[] => {
  const filters: filtersType[] = [
    {
      name: 'id',
      label: 'ID',
      placeholder: 'ID',
      type: 'input-integer',
      value: currentFilters?.id,
      options: {
        width: '170px',
        tooltip: 'ID',
      },
    },
    /*{
      name: 'stage',
      label: 'Стадия',
      placeholder: 'Выберите стадию',
      type: 'select',
      value: currentFilters?.stage,
      options: {
        width: '170px',
        enum: stages.map(item => ({ label: item.name, value: item.code })),
        tooltip: 'Стадия',
      },
    },*/
    {
      name: 'fio',
      label: 'ФИО',
      placeholder: 'ФИО',
      type: 'input-string',
      value: currentFilters?.fio,
      options: {
        width: '170px',
        tooltip: 'ФИО',
      },
    },
    {
      name: 'phone',
      label: 'Телефон',
      placeholder: 'Телефон',
      type: 'phone',
      value: currentFilters?.phone,
      options: {
        width: '170px',
        tooltip: 'Телефон',
      },
    },
    {
      name: 'manager_id',
      label: 'Менеджер',
      placeholder: 'Менеджер',
      type: 'select',
      value: currentFilters?.manager_id,
      options: {
        width: '170px',
        enum: availableFilters?.interview_responsible || [],
        tooltip: 'Менеджер',
      },
    },
    {
      name: 'department',
      label: 'Отдел',
      placeholder: 'Отдел',
      type: 'select',
      value: currentFilters?.department,
      options: {
        width: '170px',
        enum: availableFilters?.department || [],
        tooltip: 'Отдел',
      },
    },
    {
      name: 'vacancy',
      label: 'Вакансия',
      placeholder: 'Вакансия',
      type: 'select',
      value: currentFilters?.vacancy,
      options: {
        width: '170px',
        enum: availableFilters?.vacancy || [],
        tooltip: 'Вакансия',
      },
    },
    {
      name: 'federal_district_id',
      label: 'Округ',
      placeholder: 'Округ',
      type: 'select',
      value: currentFilters?.federal_district_id,
      options: {
        width: '170px',
        enum: availableFilters?.federal_district_id || [],
        tooltip: 'Округ',
      },
    },
    {
      name: 'region_id',
      label: 'Регион',
      placeholder: 'Регион',
      type: 'select',
      value: currentFilters?.region_id,
      options: {
        width: '170px',
        enum: availableFilters?.region_id || [],
        tooltip: 'Регион',
      },
    },
    {
      name: 'city_id',
      label: 'Город',
      placeholder: 'Город',
      type: 'select',
      value: currentFilters?.city_id,
      options: {
        width: '170px',
        enum: availableFilters?.city_id || [],
        tooltip: 'Город',
      },
    },
    {
      name: 'district_id',
      label: 'Район',
      placeholder: 'Район',
      type: 'select',
      value: currentFilters?.district_id,
      options: {
        width: '170px',
        enum: availableFilters?.district_id || [],
        tooltip: 'Район',
      },
    },
    {
      name: 'resource',
      label: 'Ресурс',
      placeholder: 'Ресурс',
      type: 'select',
      value: currentFilters?.resource,
      options: {
        width: '170px',
        enum: availableFilters?.resource || [],
        tooltip: 'Ресурс',
      },
    },
    {
      name: 'interview_type',
      label: 'Тип собеседования',
      placeholder: 'Тип собеседования',
      type: 'select',
      value: currentFilters?.interview_type,
      options: {
        width: '170px',
        enum: availableFilters?.interview_type || [],
        tooltip: 'Тип собеседования',
      },
    },
    {
      name: 'cancel_reason',
      label: 'Причина отказа',
      placeholder: 'Причина отказа',
      type: 'select',
      value: currentFilters?.cancel_reason,
      options: {
        width: '170px',
        enum: availableFilters?.cancel_reason || [],
        tooltip: 'Причина отказа',
      },
    },
    {
      name: 'datetime_interview',
      label: 'Дата собеседования',
      placeholder: ['Начальная', 'Конечная'],
      type: 'dates',
      value: currentFilters?.datetime_interview,
      options: {
        width: '220px',
        tooltip: 'Дата собеседования',
      },
    },
    {
      name: 'created_at',
      label: 'Дата создания',
      placeholder: ['Начальная', 'Конечная'],
      type: 'dates',
      value: currentFilters?.created_at,
      options: {
        width: '220px',
        tooltip: 'Дата создания',
      },
    },
    {
      name: 'start_probation_period',
      label: 'Дата выхода на работу',
      placeholder: ['Начальная', 'Конечная'],
      type: 'dates',
      value: currentFilters?.start_probation_period,
      options: {
        width: '220px',
        tooltip: 'Дата выхода на работу',
      },
    },
    {
      name: 'end_probation_period',
      label: 'Дата окончания исп.срока',
      placeholder: ['Начальная', 'Конечная'],
      type: 'dates',
      value: currentFilters?.end_probation_period,
      options: {
        width: '220px',
        tooltip: 'Дата окончания исп.срока',
      },
    },
  ]

  return filters
}
